import React from 'react';
import PropTypes from 'prop-types';

const imageViewerOptions = {};

class ImageViewer extends React.Component {
  /* componentDidMount() {
    if (!window.imageViewerCustom) {
      const imageViewer = window.ImageViewer && window.ImageViewer(imageViewerOptions);
    }
  } */

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.getImageViewerInstance().show(nextProps.src);
    }
  }

  componentWillUnmount() {
    this.getImageViewerInstance().hide();
  }

  getImageViewerInstance = () => {
    if (window.customImageViewer) {
      return window.customImageViewer;
    }
    window.customImageViewer = window.ImageViewer && window.ImageViewer(imageViewerOptions);
    return window.customImageViewer;
  };

  zoomImage = () => {
    const { src } = this.props;
    this.getImageViewerInstance().show(src);
  };

  render() {
    const { src, alt, imageAttrs } = this.props;

    return <img src={src} onClick={this.zoomImage} {...imageAttrs} alt={alt} />;
  }
}

ImageViewer.defaultProps = {
  alt: '',
  src: ''
};

ImageViewer.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string
};

export default ImageViewer;
